
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_43_2752)"}},[_c('path',{attrs:{"d":"M.597 26.339C.597 12.145 12.145.597 26.339.597a5.08 5.08 0 110 10.161c-8.597 0-15.597 7-15.597 15.597a5.08 5.08 0 11-10.161 0l.016-.016z","fill":"#FE9984"}}),_c('path',{attrs:{"d":"M0 26.339C0 11.823 11.823 0 26.339 0A5.669 5.669 0 0132 5.661a5.669 5.669 0 01-5.661 5.662c-8.274 0-15 6.725-15 15a5.669 5.669 0 01-5.662 5.66C2.565 31.984 0 29.469 0 26.34zM30.823 5.66a4.495 4.495 0 00-4.484-4.484c-13.871 0-25.162 11.29-25.162 25.162a4.495 4.495 0 004.484 4.484 4.495 4.495 0 004.484-4.484c0-8.92 7.258-16.194 16.194-16.194a4.495 4.495 0 004.484-4.484z","fill":"#552C5C"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_43_2752"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h32v32H0z"}})])])])
          )
        }
      }
    